import { useEffect, useMemo } from "react";
import {spacing, zIndex, surface} from "@atlas-int/tokens";
import { ProductClass } from "@atlas-int/data/types";
import { getCategoriesForChartLegend } from "@atlas-int/viz";
import {
  VisualizationBottomRowContainer,
  VisualizationContentContainer,
  VisualizationGrid,
  VisualizationHandlesContainer,
} from "../../visualization/VizGrid";
import ProductSpaceTutorial from "./ProductSpaceTutorial";
import { useTutorial } from "./TutorialContext";
import { CategoryLabels } from "@atlas-int/viz/shared";
import { ColorBy, LegendLabels, UIView } from "@atlas-int/data";

const TutorialContainer = () => {
  const {
    isTutorialOpen,
    setIsTutorialOpen,
    dismissTutorial,
    shouldShowTutorial,
  } = useTutorial();

  useEffect(() => {
    if (shouldShowTutorial) {
      setIsTutorialOpen(true);
    }
  }, [shouldShowTutorial, setIsTutorialOpen]);

  const categoriesForLegend = useMemo(
    () =>
      getCategoriesForChartLegend({
        view: UIView.Products,
        productClass: ProductClass.HS92Products,
        clusters: true,
        colorBySelection: ColorBy.Sector,
        rcaThreshold: 1,
      }).filter((d) => d.id.split("-")[2] !== "14"),
    [],
  );

  if (!isTutorialOpen) return null;

  return (
    <>
      <div
        style={{
          zIndex: zIndex.navigation,
          backgroundColor: surface.overlay,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: spacing[10],
          pointerEvents: "auto",
        }}
        onClick={dismissTutorial}
      ></div>
      <VisualizationGrid>
        <VisualizationContentContainer>
          <ProductSpaceTutorial
            open={isTutorialOpen}
            onClose={() => setIsTutorialOpen(false)}
          />
        </VisualizationContentContainer>
        <VisualizationBottomRowContainer>
          <VisualizationHandlesContainer>
            <CategoryLabels
              legendLabel={LegendLabels.Sector}
              categories={categoriesForLegend}
              allowToggle={false}
              fullWidth={true}
            />
          </VisualizationHandlesContainer>
        </VisualizationBottomRowContainer>
      </VisualizationGrid>
    </>
  );
};

export default TutorialContainer;
